<template>
  <div class="sf-row sf-row-center">
    <div class="sf-col">
      <div class="sf-empty-state sf-empty-state-small">
        <img
          v-if="showEmptyStateImage"
          :src="$imagesRequire('empty_states/communication.svg')"
          class="sf-empty-state-image"
        />
        <div class="sf-empty-state-title">
          {{ I18n.t(`${emptyTranslationKeyPerFilter}.title`) }}
        </div>
        <div class="sf-c-text">
          {{ I18n.t(`${emptyTranslationKeyPerFilter}.sidepane_message`) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    emptyTranslationKey: {
      type: String,
      required: true,
    },
    showEmptyStateImage: {
      type: Boolean,
      required: true,
    },
    cardsFilter: {
      type: String,
      default: null,
    },
  },
  computed: {
    emptyTranslationKeyPerFilter() {
      switch (this.cardsFilter) {
        case 'note':
          return 'communication.empty_state_notes'
        case 'todo':
          return 'communication.empty_state_todos'
        case 'checklist':
          return 'communication.empty_state_checks'
      }
      return this.emptyTranslationKey
    },
  },
}
</script>
